import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { modules } from '@/data/mock-data';
import { Blocks } from 'lucide-react';

export default function ModulePlaceholder() {
  const { t } = useTranslation();
  const { code } = useParams();
  const mod = modules.find(m => m.view_url === `/modules/${code}`);

  return (
    <div className="p-6 max-w-4xl mx-auto animate-fade-in">
      <div className="flex flex-col items-center justify-center h-[50vh] text-center">
        <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
          <Blocks size={28} className="text-muted-foreground" />
        </div>
        <h1 className="text-xl font-semibold text-foreground mb-1">
          {mod?.name ?? code}
        </h1>
        <p className="text-sm text-muted-foreground max-w-md">
          {t('cat_modules.placeholder')}
        </p>
      </div>
    </div>
  );
}
